/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {SmoltSupplyBatchAddPost} from '../bioplanModels';
// @ts-ignore
import type {SmoltSupplyBatchDelete} from '../bioplanModels';
// @ts-ignore
import type {SmoltSupplyEnrichedResponse} from '../bioplanModels';
// @ts-ignore
import type {SmoltSupplyPost} from '../bioplanModels';
// @ts-ignore
import type {SmoltSupplyPostResponse} from '../bioplanModels';
// @ts-ignore
import type {SmoltSupplyPut} from '../bioplanModels';
// @ts-ignore
import type {SmoltSupplyPutResponse} from '../bioplanModels';
/**
 * PlanningSmoltSupplyApi - axios parameter creator
 * @export
 */
export const PlanningSmoltSupplyApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Batch create smolt supply
     * @param {SmoltSupplyBatchAddPost} smoltSupplyBatchAddPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesBatchAddPost: async (
      smoltSupplyBatchAddPost: SmoltSupplyBatchAddPost,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'smoltSupplyBatchAddPost' is not null or undefined
      assertParamExists('smoltSuppliesBatchAddPost', 'smoltSupplyBatchAddPost', smoltSupplyBatchAddPost);
      const localVarPath = `/smoltSupplies/batchAdd`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        smoltSupplyBatchAddPost,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Batch delete multiple smolt supplies in the same plan
     * @param {SmoltSupplyBatchDelete} smoltSupplyBatchDelete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesBatchDeletePost: async (
      smoltSupplyBatchDelete: SmoltSupplyBatchDelete,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'smoltSupplyBatchDelete' is not null or undefined
      assertParamExists('smoltSuppliesBatchDeletePost', 'smoltSupplyBatchDelete', smoltSupplyBatchDelete);
      const localVarPath = `/smoltSupplies/batchDelete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        smoltSupplyBatchDelete,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all smolt supplies, filtered by plan ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('smoltSuppliesGet', 'planId', planId);
      const localVarPath = `/smoltSupplies/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create smolt supply
     * @param {SmoltSupplyPost} smoltSupplyPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesPost: async (
      smoltSupplyPost: SmoltSupplyPost,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'smoltSupplyPost' is not null or undefined
      assertParamExists('smoltSuppliesPost', 'smoltSupplyPost', smoltSupplyPost);
      const localVarPath = `/smoltSupplies/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(smoltSupplyPost, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete smolt supply by its identifier
     * @param {string} smoltSupplyId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesSmoltSupplyIdDelete: async (
      smoltSupplyId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'smoltSupplyId' is not null or undefined
      assertParamExists('smoltSuppliesSmoltSupplyIdDelete', 'smoltSupplyId', smoltSupplyId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('smoltSuppliesSmoltSupplyIdDelete', 'planId', planId);
      const localVarPath = `/smoltSupplies/{smoltSupplyId}`.replace(
        `{${'smoltSupplyId'}}`,
        encodeURIComponent(String(smoltSupplyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get smolt supply by its identifier
     * @param {string} smoltSupplyId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesSmoltSupplyIdGet: async (
      smoltSupplyId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'smoltSupplyId' is not null or undefined
      assertParamExists('smoltSuppliesSmoltSupplyIdGet', 'smoltSupplyId', smoltSupplyId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('smoltSuppliesSmoltSupplyIdGet', 'planId', planId);
      const localVarPath = `/smoltSupplies/{smoltSupplyId}`.replace(
        `{${'smoltSupplyId'}}`,
        encodeURIComponent(String(smoltSupplyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update smolt supply
     * @param {string} smoltSupplyId
     * @param {SmoltSupplyPut} smoltSupplyPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesSmoltSupplyIdPut: async (
      smoltSupplyId: string,
      smoltSupplyPut: SmoltSupplyPut,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'smoltSupplyId' is not null or undefined
      assertParamExists('smoltSuppliesSmoltSupplyIdPut', 'smoltSupplyId', smoltSupplyId);
      // verify required parameter 'smoltSupplyPut' is not null or undefined
      assertParamExists('smoltSuppliesSmoltSupplyIdPut', 'smoltSupplyPut', smoltSupplyPut);
      const localVarPath = `/smoltSupplies/{smoltSupplyId}`.replace(
        `{${'smoltSupplyId'}}`,
        encodeURIComponent(String(smoltSupplyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(smoltSupplyPut, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningSmoltSupplyApi - functional programming interface
 * @export
 */
export const PlanningSmoltSupplyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningSmoltSupplyApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Batch create smolt supply
     * @param {SmoltSupplyBatchAddPost} smoltSupplyBatchAddPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async smoltSuppliesBatchAddPost(
      smoltSupplyBatchAddPost: SmoltSupplyBatchAddPost,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SmoltSupplyPostResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.smoltSuppliesBatchAddPost(
        smoltSupplyBatchAddPost,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSmoltSupplyApi.smoltSuppliesBatchAddPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Batch delete multiple smolt supplies in the same plan
     * @param {SmoltSupplyBatchDelete} smoltSupplyBatchDelete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async smoltSuppliesBatchDeletePost(
      smoltSupplyBatchDelete: SmoltSupplyBatchDelete,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.smoltSuppliesBatchDeletePost(
        smoltSupplyBatchDelete,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSmoltSupplyApi.smoltSuppliesBatchDeletePost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all smolt supplies, filtered by plan ID
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async smoltSuppliesGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SmoltSupplyEnrichedResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.smoltSuppliesGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSmoltSupplyApi.smoltSuppliesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create smolt supply
     * @param {SmoltSupplyPost} smoltSupplyPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async smoltSuppliesPost(
      smoltSupplyPost: SmoltSupplyPost,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmoltSupplyPostResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.smoltSuppliesPost(smoltSupplyPost, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSmoltSupplyApi.smoltSuppliesPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete smolt supply by its identifier
     * @param {string} smoltSupplyId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async smoltSuppliesSmoltSupplyIdDelete(
      smoltSupplyId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.smoltSuppliesSmoltSupplyIdDelete(
        smoltSupplyId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSmoltSupplyApi.smoltSuppliesSmoltSupplyIdDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get smolt supply by its identifier
     * @param {string} smoltSupplyId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async smoltSuppliesSmoltSupplyIdGet(
      smoltSupplyId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmoltSupplyEnrichedResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.smoltSuppliesSmoltSupplyIdGet(
        smoltSupplyId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSmoltSupplyApi.smoltSuppliesSmoltSupplyIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update smolt supply
     * @param {string} smoltSupplyId
     * @param {SmoltSupplyPut} smoltSupplyPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async smoltSuppliesSmoltSupplyIdPut(
      smoltSupplyId: string,
      smoltSupplyPut: SmoltSupplyPut,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmoltSupplyPutResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.smoltSuppliesSmoltSupplyIdPut(
        smoltSupplyId,
        smoltSupplyPut,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSmoltSupplyApi.smoltSuppliesSmoltSupplyIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningSmoltSupplyApi - factory interface
 * @export
 */
export const PlanningSmoltSupplyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningSmoltSupplyApiFp(configuration);
  return {
    /**
     *
     * @summary Batch create smolt supply
     * @param {PlanningSmoltSupplyApiSmoltSuppliesBatchAddPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesBatchAddPost(
      requestParameters: PlanningSmoltSupplyApiSmoltSuppliesBatchAddPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<SmoltSupplyPostResponse>> {
      return localVarFp
        .smoltSuppliesBatchAddPost(requestParameters.smoltSupplyBatchAddPost, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Batch delete multiple smolt supplies in the same plan
     * @param {PlanningSmoltSupplyApiSmoltSuppliesBatchDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesBatchDeletePost(
      requestParameters: PlanningSmoltSupplyApiSmoltSuppliesBatchDeletePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .smoltSuppliesBatchDeletePost(requestParameters.smoltSupplyBatchDelete, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all smolt supplies, filtered by plan ID
     * @param {PlanningSmoltSupplyApiSmoltSuppliesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesGet(
      requestParameters: PlanningSmoltSupplyApiSmoltSuppliesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<SmoltSupplyEnrichedResponse>> {
      return localVarFp.smoltSuppliesGet(requestParameters.planId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create smolt supply
     * @param {PlanningSmoltSupplyApiSmoltSuppliesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesPost(
      requestParameters: PlanningSmoltSupplyApiSmoltSuppliesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SmoltSupplyPostResponse> {
      return localVarFp
        .smoltSuppliesPost(requestParameters.smoltSupplyPost, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete smolt supply by its identifier
     * @param {PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesSmoltSupplyIdDelete(
      requestParameters: PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .smoltSuppliesSmoltSupplyIdDelete(requestParameters.smoltSupplyId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get smolt supply by its identifier
     * @param {PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesSmoltSupplyIdGet(
      requestParameters: PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SmoltSupplyEnrichedResponse> {
      return localVarFp
        .smoltSuppliesSmoltSupplyIdGet(requestParameters.smoltSupplyId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update smolt supply
     * @param {PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    smoltSuppliesSmoltSupplyIdPut(
      requestParameters: PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SmoltSupplyPutResponse> {
      return localVarFp
        .smoltSuppliesSmoltSupplyIdPut(requestParameters.smoltSupplyId, requestParameters.smoltSupplyPut, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for smoltSuppliesBatchAddPost operation in PlanningSmoltSupplyApi.
 * @export
 * @interface PlanningSmoltSupplyApiSmoltSuppliesBatchAddPostRequest
 */
export interface PlanningSmoltSupplyApiSmoltSuppliesBatchAddPostRequest {
  /**
   *
   * @type {SmoltSupplyBatchAddPost}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesBatchAddPost
   */
  readonly smoltSupplyBatchAddPost: SmoltSupplyBatchAddPost;
}

/**
 * Request parameters for smoltSuppliesBatchDeletePost operation in PlanningSmoltSupplyApi.
 * @export
 * @interface PlanningSmoltSupplyApiSmoltSuppliesBatchDeletePostRequest
 */
export interface PlanningSmoltSupplyApiSmoltSuppliesBatchDeletePostRequest {
  /**
   *
   * @type {SmoltSupplyBatchDelete}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesBatchDeletePost
   */
  readonly smoltSupplyBatchDelete: SmoltSupplyBatchDelete;
}

/**
 * Request parameters for smoltSuppliesGet operation in PlanningSmoltSupplyApi.
 * @export
 * @interface PlanningSmoltSupplyApiSmoltSuppliesGetRequest
 */
export interface PlanningSmoltSupplyApiSmoltSuppliesGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesGet
   */
  readonly planId: string;
}

/**
 * Request parameters for smoltSuppliesPost operation in PlanningSmoltSupplyApi.
 * @export
 * @interface PlanningSmoltSupplyApiSmoltSuppliesPostRequest
 */
export interface PlanningSmoltSupplyApiSmoltSuppliesPostRequest {
  /**
   *
   * @type {SmoltSupplyPost}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesPost
   */
  readonly smoltSupplyPost: SmoltSupplyPost;
}

/**
 * Request parameters for smoltSuppliesSmoltSupplyIdDelete operation in PlanningSmoltSupplyApi.
 * @export
 * @interface PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdDeleteRequest
 */
export interface PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdDelete
   */
  readonly smoltSupplyId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for smoltSuppliesSmoltSupplyIdGet operation in PlanningSmoltSupplyApi.
 * @export
 * @interface PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdGetRequest
 */
export interface PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdGet
   */
  readonly smoltSupplyId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for smoltSuppliesSmoltSupplyIdPut operation in PlanningSmoltSupplyApi.
 * @export
 * @interface PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdPutRequest
 */
export interface PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdPut
   */
  readonly smoltSupplyId: string;

  /**
   *
   * @type {SmoltSupplyPut}
   * @memberof PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdPut
   */
  readonly smoltSupplyPut: SmoltSupplyPut;
}

/**
 * PlanningSmoltSupplyApi - object-oriented interface
 * @export
 * @class PlanningSmoltSupplyApi
 * @extends {BaseAPI}
 */
export class PlanningSmoltSupplyApi extends BaseAPI {
  /**
   *
   * @summary Batch create smolt supply
   * @param {PlanningSmoltSupplyApiSmoltSuppliesBatchAddPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSmoltSupplyApi
   */
  public smoltSuppliesBatchAddPost(
    requestParameters: PlanningSmoltSupplyApiSmoltSuppliesBatchAddPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSmoltSupplyApiFp(this.configuration)
      .smoltSuppliesBatchAddPost(requestParameters.smoltSupplyBatchAddPost, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Batch delete multiple smolt supplies in the same plan
   * @param {PlanningSmoltSupplyApiSmoltSuppliesBatchDeletePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSmoltSupplyApi
   */
  public smoltSuppliesBatchDeletePost(
    requestParameters: PlanningSmoltSupplyApiSmoltSuppliesBatchDeletePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSmoltSupplyApiFp(this.configuration)
      .smoltSuppliesBatchDeletePost(requestParameters.smoltSupplyBatchDelete, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all smolt supplies, filtered by plan ID
   * @param {PlanningSmoltSupplyApiSmoltSuppliesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSmoltSupplyApi
   */
  public smoltSuppliesGet(
    requestParameters: PlanningSmoltSupplyApiSmoltSuppliesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSmoltSupplyApiFp(this.configuration)
      .smoltSuppliesGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create smolt supply
   * @param {PlanningSmoltSupplyApiSmoltSuppliesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSmoltSupplyApi
   */
  public smoltSuppliesPost(
    requestParameters: PlanningSmoltSupplyApiSmoltSuppliesPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSmoltSupplyApiFp(this.configuration)
      .smoltSuppliesPost(requestParameters.smoltSupplyPost, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete smolt supply by its identifier
   * @param {PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSmoltSupplyApi
   */
  public smoltSuppliesSmoltSupplyIdDelete(
    requestParameters: PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSmoltSupplyApiFp(this.configuration)
      .smoltSuppliesSmoltSupplyIdDelete(requestParameters.smoltSupplyId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get smolt supply by its identifier
   * @param {PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSmoltSupplyApi
   */
  public smoltSuppliesSmoltSupplyIdGet(
    requestParameters: PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSmoltSupplyApiFp(this.configuration)
      .smoltSuppliesSmoltSupplyIdGet(requestParameters.smoltSupplyId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update smolt supply
   * @param {PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSmoltSupplyApi
   */
  public smoltSuppliesSmoltSupplyIdPut(
    requestParameters: PlanningSmoltSupplyApiSmoltSuppliesSmoltSupplyIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSmoltSupplyApiFp(this.configuration)
      .smoltSuppliesSmoltSupplyIdPut(requestParameters.smoltSupplyId, requestParameters.smoltSupplyPut, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
